import { combineReducers } from 'redux';
import types from './types';

const zones = (state = [], action) => {
  switch (action.type) {
    case types.GET_ZONES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const assessment = (state = null, action) => {
  switch (action.type) {
    case types.RUN_ASSESSMENT_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const ubhpsFeatures = (state = {}, action) => {
  switch (action.type) {
    case types.GET_UBHPS_FEATURES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const communityImpact = (state = null, action) => {
  switch (action.type) {
    case types.SET_COMMUNITY_IMPACT:
      return action.payload;
    default:
      return state;
  }
};

const loading = (state = false, action) => {
  switch (action.type) {
    case types.GET_ZONES:
    case types.CREATE_ZONE:
    case types.RUN_ASSESSMENT:
      return true;
    case types.GET_ZONES_SUCCESS:
    case types.GET_ZONES_FAILURE:
    case types.CREATE_ZONE_SUCCESS:
    case types.CREATE_ZONE_FAILURE:
    case types.RUN_ASSESSMENT_SUCCESS:
      return false;
    default:
      return state;
  }
};

const reducer = combineReducers({
  zones,
  assessment,
  ubhpsFeatures,
  communityImpact,
  loading,
});

export default reducer;
